import { TransferKey } from 'antd/es/transfer/interface';
import { Key, useCallback, useState } from 'react';

export function useTransfer() {
  const [selectedKeys, setSelectedKeys] = useState<Key[]>([]);

  const onSelectChange = useCallback(
    (sourceSelectedKeys: TransferKey[], targetSelectedKeys: TransferKey[]) => { 
      setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys]);
    },
    [setSelectedKeys]
  );

  return {
    selectedKeys,
    onSelectChange,
  };
}
